/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports
import { css, jsx } from '@emotion/react';

import { MediaBorderGapFiller } from '@atlaskit/editor-common/MediaSingle/styled';
import type { NumericalCardDimensions } from '@atlaskit/media-common/main-types';

export const MediaSingleNodeSelector = 'media-single-node';

const absoluteDivStyles = css({
	position: 'absolute',
	width: '100%',
	height: '100%',
});

const forcedDimensionsStyles = css({
	width: '100%',
	position: 'relative',
});

const pointerCursorStyle = css({
	cursor: 'pointer',
});

type MediaCardWrapperProps = {
	borderWidth?: number;
	children: React.ReactNode;
	dimensions: NumericalCardDimensions;
	onContextMenu?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
	onFocus?: (event: React.FocusEvent<HTMLElement>) => void;
	onMouseEnter?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
	selected?: boolean;
};

export const MediaCardWrapper = ({
	dimensions,
	children,
	selected,
	borderWidth = 0,
	onContextMenu,
	onFocus,
	onMouseEnter,
}: MediaCardWrapperProps): jsx.JSX.Element => {
	const calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
	const borderRadius = `${calculatedBorderWidth + 8}px`;

	return (
		<div
			data-testid="media-card-wrapper"
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			className="media-card-wrapper"
			css={pointerCursorStyle}
			onFocus={onFocus}
			onMouseEnter={onMouseEnter}
			style={{
				borderColor: `var(--custom-palette-color)`,
				borderWidth: `${calculatedBorderWidth}px`,
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				borderStyle: 'solid',
				// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
				borderRadius,
			}}
		>
			<div
				css={forcedDimensionsStyles}
				style={{
					paddingBottom: `${(dimensions.height / dimensions.width) * 100}%`,
				}}
				onContextMenuCapture={onContextMenu}
			>
				{borderWidth > 0 && <MediaBorderGapFiller borderColor={`var(--custom-palette-color)`} />}
				<div css={absoluteDivStyles}>{children}</div>
			</div>
		</div>
	);
};
